import {REGISTRY_SINGLETON} from '../../scenes/Registry';
import {queueUnitStarvationDeaths} from '../../scenes/playUnitStarvationEffects';
import {resolveStarvedUnits} from '../../utils/gameState/supply/resolveStarvedUnits';

/**
 * Гибель от голода запускается здесь, сразу после того, как конец фазы снабжения прошел
 * редьюсер: фазу закрывает и свой ход, и бот, и сервер, и запись матча. Поле перерисуется
 * позже, поэтому отряд, придержанный здесь, не исчезнет ни на кадр.
 */
export const createUnitStarvationAnimationMiddleware = ({
  getHexGridRenderer,
  getSoundManager,
  queue = queueUnitStarvationDeaths,
}) => (store) => (next) => (action) => {
  if (action?.type !== 'COMPLETE_PHASE') {
    return next(action);
  }

  const prevState = store.getState();
  const result = next(action);

  try {
    const units = resolveStarvedUnits(prevState, store.getState(), action);
    if (units.length > 0) {
      queue(store, {units, getHexGridRenderer, getSoundManager});
    }
  } catch (error) {
    // Анимация — украшение: ее поломка не должна ронять диспатч
    console.warn('[UnitStarvation] не удалось показать гибель от голода', error);
  }

  return result;
};

const unitStarvationAnimationMiddleware = createUnitStarvationAnimationMiddleware({
  getHexGridRenderer: () => REGISTRY_SINGLETON.getHexGridRenderer(),
  getSoundManager: () => REGISTRY_SINGLETON.getSoundManager(),
});

export default unitStarvationAnimationMiddleware;
